import { NoRecordFound } from 'components/Common/Common'
import ConfirmationPop from 'components/Modals/ConfirmationPop'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayout from 'components/TableLayout'
// import { START_SESSION } from 'config/paths'
// import Images from 'constant/Images'
import { convertToMomentDate, formatString, successMessageToast, userFullName } from 'helpers/common'
import React, { useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
// import { useGetTaskDetailsQuery, useMarkTaskCompleteMutation } from 'store/services/task'
import { useGetStaffTaskListQuery,useGetClientTaskQuery } from "store/services/staff";

const START_SESSION = "/start-session/:taskId/:clientId"

const ParentTasksView = () => {

    const navigate = useNavigate();
    // const [showModal, setShowModal] = useState(false);
    // const [currentEntry, setCurrentEntry] = useState(null);

    // const { id: clientId, taskStatus = "" } = useParams();
    // const { data, isFetching, refetch, isLoading } = useGetTaskDetailsQuery({ clientId, taskStatus }, { skip: !clientId });
    // const task = data?.tasks?.[0];
    // const [completeTask, { isLoading: completeTaskLoading }] = useMarkTaskCompleteMutation();


    //   const { taskType, clientId , taskId } = useParams();
       const { staffId, taskType, clientId , taskId } = useParams();

       const abc = useParams();
       console.log(" paramms", abc)

    
      const [pageSize, setPageSize] = useState(10);
      const [currentPage, setCurrentPage] = useState(1);
      const [filter, setFilter] = useState({ search: "", sort: { column: "id", direction: "desc" } });
    
    //   const staffId = '';
      const { data, isLoading, isError, isFetching } = useGetClientTaskQuery({ id: staffId, clientId, taskType, taskId, payload: { page: currentPage, limit: pageSize, ...filter } });
      const totalRecords = data?.totalRecords || 0;
      const totalPages = Math.ceil(totalRecords / pageSize);
      const task= data?.records;

      console.log("task",data);

    //   const client_detail = data?.clientDetails?.associatedGuardianClient || '';
      const client_detail = data?.record?.associatedClient || '';
      const taskDetails = data?.record || '';  

      console.log("task detasd", taskDetails?.associatedTasks?.task_title);

    const column = [
        {
            head: "Schedule Date",
            accessor: "Session Date",
            isComponent: true,
            component: (item, ind) => (
                <>{convertToMomentDate(item?.schedule_date)}</>
            ),
        },
        {
            head: "Attendance",
            accessor: "Tracker",
            component: (item, ind) => (
                <div className='text-capitalize'>{item?.attendance || "--"}</div>
            ),
        },
        {
            head: "Status",
            accessor: "Confirmed",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 110 }}
                    className={`${item?.status == "pending"
                        ? "redStatus"
                        : "greenStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {formatString(item?.status)}
                </p>
            ),
        },
        {
            head: "Action",
            accessor: "Action",
            isComponent: true,
            component: (item, ind) => (
                <>
                    <Button
                        className='commonBtn p-0'
                        style={{ height: "30px", minWidth: "100px" }}
                        onClick={() => navigate(START_SESSION.replace(":clientId", clientId).replace(":taskId", item?.assigned_task_id))}
                    >
                        Target Plan
                    </Button>
                </>
            ),
        },
    ];


   

    return (
        isLoading ? <LoadingIndicator /> : <>
         
            <section className='mt-3 border-bottom'>
                <Container fluid>
                    <Row className='justify-content-between align-items-center'>
                        <Col lg='6'>
                            <p className='mb-0'>Clients/ <span className='mb-0' style={{ fontWeight: "600" }}>Task Details</span></p>
                        </Col>                     
                    </Row>
                </Container>
            </section>

            <section className='mt-4'>
                <Container fluid>
                    <h4 className='m-0 fw-bold themeBlue text-capitalize'>{userFullName(client_detail)}</h4>
                    <Row>
                        <Col lg='8'>
                            <Row>
                                <Col md="4" sm="6" className='my-2'>
                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 class="m-0 themeBlue fw-bold">
                                            <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                ■</span>{" "}
                                            Last Name
                                        </h6><p class="m-0 themeBlue pt-2">{client_detail?.lastname || "--"}
                                        </p>
                                    </div>
                                </Col>
                                <Col md="4" sm="6" className='my-2'>
                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 class="m-0 themeBlue fw-bold">
                                            <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                ■</span>{" "}
                                            First Name
                                        </h6><p class="m-0 themeBlue pt-2">{client_detail?.firstname || "--"}
                                        </p>
                                    </div>
                                </Col>
                                <Col md="4" sm="6" className='my-2'>
                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 class="m-0 themeBlue fw-bold">
                                            <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                ■</span>{" "}
                                            DOB
                                        </h6><p class="m-0 themeBlue pt-2">{convertToMomentDate(client_detail?.client_detail?.dob || "--")}
                                        </p>
                                    </div>
                                </Col>
                                {/* <Col md="4" sm="6" className='my-2'>
                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 class="m-0 themeBlue fw-bold">
                                            <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                ■</span>{" "}
                                            Name of Discipline
                                        </h6><p class="m-0 themeBlue pt-2">{task?.associatedTasks?.owner?.therapist_detail?.therapist_discipline?.name || "--"}
                                        </p>
                                    </div>
                                </Col> */}
                                {/* <Col md="4" sm="6" className='my-2'>
                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 class="m-0 themeBlue fw-bold">
                                            <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                ■</span>{" "}
                                            Supervisor
                                        </h6><p class="m-0 themeBlue pt-2 text-capitalize">{userFullName(task?.associatedTasks?.owner) || "--"}
                                        </p>
                                    </div>
                                </Col> */}
                                <Col md="4" sm="6" className='my-2'>
                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 class="m-0 themeBlue fw-bold">
                                            <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                ■</span>{" "}
                                            Categories Name
                                        </h6><p class="m-0 themeBlue pt-2">{client_detail?.client_detail?.client_type || "--"}
                                        </p>
                                    </div>
                                </Col>
                                <Col md="4" sm="6" className='my-2'>
                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 class="m-0 themeBlue fw-bold">
                                            <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                ■</span>{" "}
                                            Grade
                                        </h6>
                                        <p class="m-0 themeBlue pt-2">{client_detail?.client_detail?.grade || "--"}</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        
                    </Row>
                </Container>
            </section >


            <section className='mt-4'>
                <Container fluid className=''>
                    {
                        // !taskDetails?.length ? <NoRecordFound /> : data?.tasks?.map((item, index) => {
                        //     return (
                                // <div key={index} className='p-4 pb-0 rounded' style={{ backgroundColor: "#3DA0AA17" }}>
                                <div className='p-4 pb-0 rounded' style={{ backgroundColor: "#3DA0AA17" }}>
                                    <div className="pb-4 h-100 rounded d-flex align-items-center">
                                        <h6 class="m-0 themeBlue fw-bold">
                                            <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                ■</span>{" "}
                                            Date
                                        </h6>
                                        <div className='d-flex ms-2 align-items-center'>
                                            <p class="m-0 themeBlue ms-1">
                                                {/* {convertToMomentDate(item?.associatedTasks?.createdAt)} */}
                                                {convertToMomentDate(taskDetails?.associatedTasks?.task_datetime)}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className='d-flex flex-colomn'>
                                            <h5 className='m-0 fw-bold themeBlue text-capitalize'>{taskDetails?.associatedTasks?.task_title || "--"}</h5>
                                            <h6 className='m-0 themeBlue'>{taskDetails?.associatedTasks?.description || "--"}</h6>
                                        </div>
                    
                                        <Button                                            
                                            disabled={taskDetails?.associatedTasks?.status === 'completed' ? true : false}
                                            className='commonBtn btn btn-primary p-0'
                                            style={{ height: "35px", 
                                                     backgroundColor: taskDetails?.associatedTasks?.status === 'completed' ? '#45a3a5' : '',
                                                     borderColor: taskDetails?.associatedTasks?.status === 'completed' ? '#45a3a5' : ''
                                             }}
                                        >
                                            {taskDetails?.associatedTasks?.status === 'completed' ? 'Marked Completed' : 'Mark Complete'}
                                        </Button>

                                    </div>
                                    {/* <div className='group-details-table'>
                                        <TableLayout column={column} data={taskDetails?.occurrences || []} />
                                    </div> */}
                                </div>
                        //     )
                        // })
                    }
                </Container>
            </section>
        </>
    )
}

export default ParentTasksView



 